import { render, staticRenderFns } from "./menu-layout.vue?vue&type=template&id=68c1a12e&scoped=true"
import script from "./menu-layout.vue?vue&type=script&lang=js"
export * from "./menu-layout.vue?vue&type=script&lang=js"
import style0 from "./menu-layout.vue?vue&type=style&index=0&id=68c1a12e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c1a12e",
  null
  
)

export default component.exports